import { Skeleton } from '@mui/material';
import './SkeletonList.scss';

const SkeletonList = () => {
  // const str = document.querySelector('.skl-list');
  // window.addEventListener(
  //   'resize',
  //   () => {
  //     console.log(str.getBoundingClientRect().height);
  //   },
  //   true
  // );
  return (
    <div className="skl">
      {[...Array(10)].map((_, index) => (
        <Skeleton
          className="skl-item"
          key={index}
          sx={{ marginTop: '8px' }}
          height={60}
          animation="wave"
        />
      ))}
    </div>
  );
};
export default SkeletonList;
